var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-wrapper',{attrs:{"modal":_vm.modal}},[_c(_vm.modal.name,{tag:"component",attrs:{"modal":_vm.modal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }